import ReadMore from '@mui/icons-material/ReadMore';
import { FC, memo } from 'react';

import {
  StyledBox,
  StyledH3,
  StyledIconButton,
  StyledImageList,
  StyledImageListItem,
  StyledImg,
  StyledP,
} from './styled';
import { CardDeckProps } from './type';
import { CARD_H, CARD_W, GAP, IMG_H } from './utils';

const CARD_ID_PREFIX = 'card-deck-';
const IMG_PREFIX = '/img/poster-kampfkunst-feature-';
const IMG_SUFFIX = '.jpg';

const CardDeck: FC<CardDeckProps> = ({ cards, onCardClick, sx }) => {
  const width = cards.length * CARD_W + (cards.length - 1) * GAP;

  return (
    <StyledImageList cols={cards.length} gap={GAP} rowHeight={CARD_H} sx={{ ...sx, width }}>
      {cards.map(card => (
        <StyledImageListItem id={`${CARD_ID_PREFIX}${card.id}`} key={card.id}>
          <StyledImg
            alt={card.name}
            loading='lazy'
            onClick={() => onCardClick?.(card.id)}
            src={`${IMG_PREFIX}${card.image}${IMG_SUFFIX}`}
            style={{ height: IMG_H, width: CARD_W }}
          />

          <StyledIconButton
            aria-controls={`${CARD_ID_PREFIX}${card.id}`}
            aria-label={`Mehr anzeigen über ${card.name}`}
            onClick={() => onCardClick?.(card.id)}
          >
            <ReadMore />
          </StyledIconButton>

          <StyledBox>
            <StyledH3>{card.name}</StyledH3>
            <StyledP>{card.short}</StyledP>
          </StyledBox>
        </StyledImageListItem>
      ))}
    </StyledImageList>
  );
};

export default memo(CardDeck);
